import React, { Component } from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import { connect } from "react-redux";
import { BeatLoader } from "react-spinners";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import SingleCsvReportDownload from "../components/DownloadReport/SingleCsvReportDownload.jsx";
import LastRefresh from './LastRefresh.jsx';
import {
    PURPLE, DARK_ROW,
    GREEN_TXT, ORANGE_TXT, RED_TXT,
    HEADER_TH, SUB_HEADER_TH, DATA_TD, TEXT_TD, GROUP_TD,
    spinnerOverride as override, CheckIcon, CrossIcon
} from './reportConstants';

// ASE Performance Report. Data-driven from the Flask
// /service_reports/aso-ase-performance-report endpoint (via the node
// /InternalReport/aso-ase-performance-report proxy). The month columns, values
// and cell colours all come from the API. Each ASE group ships team-level OKR
// roll-ups (okr1_team_performance_pct / okr2_team_attendance_pct); expanding an
// ASE reveals the per-ASO numbers (okr1_avg_performance / okr2_days_present).
class ASEPerformanceReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            error: null,
            expandedASEs: {},
            optionsBuilt: false,

            aseList: [], asoList: [], stateList: [], cityList: [],
            aseValue: [], asoValue: [], stateValue: [], cityValue: [],
        };
    }

    componentWillMount() {
        this.props.currentMenu("ase_performance_report");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
        });
    }

    componentDidMount() {
        this.get_report();
    }

    activeFilters(extra) {
        return {
            ase: this.state.aseValue.map(o => o.value),
            aso: this.state.asoValue.map(o => o.value),
            state: this.state.stateValue.map(o => o.value),
            city: this.state.cityValue.map(o => o.value),
            ...extra,
        };
    }

    get_report() {
        this.setState({ loading: true, error: null });
        axios.post(config.get('API_URL') + '/InternalReport/aso-ase-performance-report',
            this.activeFilters({ download: 0 }),
            { headers: { Authorization: localStorage.usertoken } }
        )
        .then(response => {
            const data = response.data && response.data.data ? response.data.data : null;
            this.setState(prevState => {
                const next = {
                    data,
                    loading: false,
                    error: data ? null : "No data available",
                };
                if (data) {
                    const expanded = {};
                    (data.ase_list || []).forEach(ase => { expanded[ase.ase_name] = true; });
                    next.expandedASEs = expanded;
                    if (!prevState.optionsBuilt) {
                        Object.assign(next, this.buildFilterOptions(data), { optionsBuilt: true });
                    }
                }
                return next;
            });
        })
        .catch(error => {
            console.error("ASE performance API error:", error);
            this.setState({ loading: false, error: "Failed to load data" });
        });
    }

    // Derive the four filter dropdowns from the full dataset.
    buildFilterOptions(data) {
        const aseSet = new Set(), asoSet = new Set(), stateSet = new Set(), citySet = new Set();
        (data.ase_list || []).forEach(ase => {
            if (ase.ase_name) aseSet.add(ase.ase_name);
            (ase.asos || []).forEach(aso => {
                if (aso.aso_name) asoSet.add(aso.aso_name);
                if (aso.state) stateSet.add(aso.state);
                if (aso.city) citySet.add(aso.city);
            });
        });
        const toOpts = set => [...set].sort().map(v => ({ value: v, label: v }));
        return {
            aseList: toOpts(aseSet),
            asoList: toOpts(asoSet),
            stateList: toOpts(stateSet),
            cityList: toOpts(citySet),
        };
    }

    changeAse = (selected) => this.setState({ aseValue: selected || [] });
    changeAso = (selected) => this.setState({ asoValue: selected || [] });
    changeState = (selected) => this.setState({ stateValue: selected || [] });
    changeCity = (selected) => this.setState({ cityValue: selected || [] });

    applyFilters = () => this.get_report();

    resetFilters = () => {
        this.setState({
            aseValue: [], asoValue: [], stateValue: [], cityValue: [],
        }, () => this.get_report());
    }

    handleDownload = () => {
        if (!this.state.data) return;
        this.refs.csvDownload.downLoadReport(
            this.activeFilters({ download: 1 }),
            '/service_reports/aso-ase-performance-report',
            'ase_performance',
            9999
        );
    }

    toggleASEExpand = (aseName) => {
        this.setState(prevState => ({
            expandedASEs: {
                ...prevState.expandedASEs,
                [aseName]: !prevState.expandedASEs[aseName]
            }
        }));
    }

    // The API ships the cell colour (e.g. '#FFCCCC'); pick a matching text colour.
    apiColorStyle(hex) {
        if (!hex) return { backgroundColor: 'transparent', color: '#333' };
        const h = hex.toUpperCase();
        if (h === '#FFCCCC' || h === '#FFE2E2') return { backgroundColor: hex, color: RED_TXT };
        if (h === '#CCFFCC' || h === '#DCFCE7') return { backgroundColor: hex, color: GREEN_TXT };
        if (h === '#FFFFCC' || h === '#FFEBD5') return { backgroundColor: hex, color: ORANGE_TXT };
        return { backgroundColor: hex, color: '#333' };
    }

    isGreen(hex) {
        if (!hex) return null;
        const h = hex.toUpperCase();
        if (h === '#CCFFCC' || h === '#DCFCE7') return true;
        if (h === '#FFCCCC' || h === '#FFE2E2') return false;
        return null;
    }

    fmtPerf(v) {
        if (v === null || v === undefined || v === '') return '-';
        return `${v}%`;
    }

    fmtDays(v) {
        if (v === null || v === undefined || v === '') return '-';
        return v;
    }

    // Build a { label -> entry } lookup so we can render in the report's month order.
    byLabel(arr) {
        const map = {};
        (arr || []).forEach(item => { map[item.label] = item; });
        return map;
    }

    renderFilters() {
        return (
            <div className="content" style={{ backgroundColor: '#f5f5f5', padding: '15px 15px 15px 25px', marginBottom: '15px' }}>
                <div className="row">
                    <div className="col-md-2 filter-bottom5 padd-5">
                        <ReactMultiSelectCheckboxes
                            name="ase" isMulti
                            value={this.state.aseValue}
                            options={this.state.aseList}
                            onChange={this.changeAse}
                            placeholderButtonLabel="Select [ASE]"
                            className="report-listbox"
                            isClearable={true}
                        />
                        <div className="clearfix"></div>
                    </div>
                    <div className="col-md-2 filter-bottom5 padd-5">
                        <ReactMultiSelectCheckboxes
                            name="aso" isMulti
                            value={this.state.asoValue}
                            options={this.state.asoList}
                            onChange={this.changeAso}
                            placeholderButtonLabel="Select [ASO]"
                            className="report-listbox"
                            isClearable={true}
                        />
                        <div className="clearfix"></div>
                    </div>
                    <div className="col-md-2 filter-bottom5 padd-5">
                        <ReactMultiSelectCheckboxes
                            name="state" isMulti
                            value={this.state.stateValue}
                            options={this.state.stateList}
                            onChange={this.changeState}
                            placeholderButtonLabel="Select [State]"
                            className="report-listbox"
                            isClearable={true}
                        />
                        <div className="clearfix"></div>
                    </div>
                    <div className="col-md-2 filter-bottom5 padd-5">
                        <ReactMultiSelectCheckboxes
                            name="city" isMulti
                            value={this.state.cityValue}
                            options={this.state.cityList}
                            onChange={this.changeCity}
                            placeholderButtonLabel="Select [City]"
                            className="report-listbox"
                            isClearable={true}
                        />
                        <div className="clearfix"></div>
                    </div>
                    <div className="col-md-4 padd-5" style={{ paddingTop: '7px' }}>
                        <button type="button" className="primary apply-filter" role="button"
                            onClick={this.applyFilters}>
                            Apply
                        </button>
                        &nbsp;
                        <button type="button" className="primary reset-filter" role="button"
                            onClick={this.resetFilters}>
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    shell(children) {
        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row"><div className="col-md-12"><div className="card">
                        <div className="col-md-9 no-padd">
                            <div className="header"><h4 className="title">ASE Performance Report</h4><LastRefresh /></div>
                        </div>
                        <div className="col-md-3 pull-right">
                            <div className="r-p-menu">
                                <div className="report-header-icons">
                                    <div className="icon-button download-icon" title="Download Report"
                                        style={{ cursor: 'pointer' }} onClick={this.handleDownload}>
                                        <i className="fa fa-download"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        {this.renderFilters()}
                        <div className="clearfix"></div>
                        {children}
                        <div className="footer"><div className="stats"><i></i></div></div>
                        <SingleCsvReportDownload ref="csvDownload" />
                    </div></div></div>
                </div>
            </div>
        );
    }

    // Render the month cells for one OKR array. `attendance` adds a check/cross
    // icon (driven by the API colour) and is only used for the ASO day counts.
    renderMetricCells(arr, months, fmt, attendance) {
        const byLabel = this.byLabel(arr);
        return months.map(m => {
            const e = byLabel[m] || {};
            const green = attendance ? this.isGreen(e.color) : null;
            return (
                <td key={m} style={{ ...DATA_TD, ...this.apiColorStyle(e.color) }}>
                    {fmt(e.value)}
                    {attendance && green === true ? <CheckIcon /> : null}
                    {attendance && green === false ? <CrossIcon /> : null}
                </td>
            );
        });
    }

    render() {
        const { loading, error, data } = this.state;

        if (loading) {
            return this.shell(
                <div className="content"><BeatLoader css={override} size={15} color={"#51bcda"} loading={loading} /></div>
            );
        }
        if (error || !data) {
            return this.shell(
                <div className="content"><div className="alert alert-danger">{error || "No data available"}</div></div>
            );
        }

        const months = data.months || [];
        const aseList = data.ase_list || [];
        return this.shell(
            <div className="content">
                <div className="content-tdetails-table table-responsive marginTop0" style={{ padding: 0 }}>
                    <table className="table" style={{ borderCollapse: 'separate', borderSpacing: 0, width: '100%', tableLayout: 'fixed' }}>
                        <colgroup>
                            <col style={{ width: '200px' }} />
                            <col style={{ width: '110px' }} />
                            <col style={{ width: '110px' }} />
                            {[...Array(months.length * 2)].map((_, i) => <col key={i} style={{ width: '70px' }} />)}
                        </colgroup>
                        <thead>
                            <tr style={{ backgroundColor: PURPLE, color: 'white' }}>
                                <th rowSpan={2} style={HEADER_TH}>ASE Name</th>
                                <th rowSpan={2} style={HEADER_TH}>State</th>
                                <th rowSpan={2} style={HEADER_TH}>City</th>
                                <th colSpan={months.length} style={HEADER_TH}>% of team members crossing performance target</th>
                                <th colSpan={months.length} style={HEADER_TH}>% of team members who meet the attendance target for the month</th>
                            </tr>
                            <tr style={{ backgroundColor: '#fff' }}>
                                {months.map(m => <th key={`perf-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                                {months.map(m => <th key={`att-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {aseList.length === 0 ? (
                                <tr><td colSpan={3 + months.length * 2} style={{ textAlign: 'center', padding: '15px' }}>No data available</td></tr>
                            ) : aseList.map((ase, aseIdx) => {
                                const asos = ase.asos || [];
                                const isExpanded = this.state.expandedASEs[ase.ase_name] === true;
                                return (
                                    <React.Fragment key={aseIdx}>
                                        <tr style={{ backgroundColor: DARK_ROW, cursor: 'pointer' }}
                                            onClick={() => this.toggleASEExpand(ase.ase_name)}>
                                            <td style={GROUP_TD} colSpan={3}>
                                                <span style={{ marginRight: '10px' }}>{isExpanded ? '▼' : '▶'}</span>
                                                {ase.ase_name} ({ase.total_asos != null ? ase.total_asos : asos.length} ASOs)
                                            </td>
                                            {this.renderMetricCells(ase.okr1_team_performance_pct, months, this.fmtPerf.bind(this), false)}
                                            {this.renderMetricCells(ase.okr2_team_attendance_pct, months, this.fmtPerf.bind(this), false)}
                                        </tr>
                                        {isExpanded && (
                                            <React.Fragment>
                                                <tr style={{ backgroundColor: PURPLE, color: 'white' }}>
                                                    <th rowSpan={2} style={HEADER_TH}>ASO Name</th>
                                                    <th rowSpan={2} style={HEADER_TH}>State</th>
                                                    <th rowSpan={2} style={HEADER_TH}>City</th>
                                                    <th colSpan={months.length} style={HEADER_TH}>Average of daily performance % for the month</th>
                                                    <th colSpan={months.length} style={HEADER_TH}>Minimum number of days marked present in the month</th>
                                                </tr>
                                                <tr style={{ backgroundColor: '#fff' }}>
                                                    {months.map(m => <th key={`sperf-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                                                    {months.map(m => <th key={`satt-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                                                </tr>
                                                {asos.map((aso, aIdx) => (
                                                    <tr key={aIdx} style={{ backgroundColor: '#fff' }}>
                                                        <td style={TEXT_TD}><strong>{aso.aso_name}</strong></td>
                                                        <td style={TEXT_TD}>{aso.state || '-'}</td>
                                                        <td style={TEXT_TD}>{aso.city || '-'}</td>
                                                        {this.renderMetricCells(aso.okr1_avg_performance, months, this.fmtPerf.bind(this), false)}
                                                        {this.renderMetricCells(aso.okr2_days_present, months, this.fmtDays.bind(this), true)}
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    currentMenu: (name) => dispatch({ type: 'change_menu', payload: name })
});

export default connect(null, mapDispatchToProps)(ASEPerformanceReport);
